"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerInfoCommands = void 0;
const api_1 = require("@cc-plugins/api");
exports.playerInfoCommands = {
    playerMatchRewardsEvent: (0, api_1.networkedAction)("playerInfo/playerMatchRewardsEvent"),
    updateStatusCommand: (0, api_1.networkedAction)("playerInfo/updateStatusCommand"),
    updateReadyCommand: (0, api_1.networkedAction)("playerInfo/updateReadyCommand"),
    updateOpponentCommand: (0, api_1.networkedAction)("playerInfo/updateOpponentCommand"),
    updateBattleCommand: (0, api_1.networkedAction)("playerInfo/updateBattleCommand"),
    updateHealthCommand: (0, api_1.networkedAction)("playerInfo/updateHealthCommand"),
    updateStreakCommand: (0, api_1.networkedAction)("playerInfo/updateStreakCommand"),
    updateLevelCommand: (0, api_1.networkedAction)("playerInfo/updateLevelCommand"),
    updateMoneyCommand: (0, api_1.networkedAction)("playerInfo/updateMoneyCommand"),
};
